(function () {
  'use strict';

  function preloadSetupImages(root) {
    root.querySelectorAll('.sc-section__image').forEach(function (img) {
      img.loading = 'eager';
      if (img.complete) return;
      var src = img.currentSrc || img.src;
      if (src) {
        var loader = new Image();
        loader.src = src;
      }
      if (img.decode) {
        img.decode().catch(function () {});
      }
    });
  }

  function initSetupCarousel(root) {
    if (!root || root.dataset.scInit === 'true') return;
    root.dataset.scInit = 'true';

    var swiperEl = root.querySelector('[data-sc-swiper]');
    if (!swiperEl || typeof Swiper === 'undefined') return;

    preloadSetupImages(root);

    if (swiperEl.swiper) {
      swiperEl.swiper.destroy(true, true);
    }

    new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 16,
      speed: 450,
      loop: false,
      simulateTouch: true,
      allowTouchMove: true,
      touchStartPreventDefault: false,
      watchOverflow: false,
      grabCursor: true,
      breakpoints: {
        640: {
          slidesPerView: 2
        },
        768: {
          slidesPerView: 3
        },
        991: {
          slidesPerView: 4
        },
        1200: {
          slidesPerView: 5
        }
      }
    });
  }

  function boot() {
    if (typeof Swiper === 'undefined') return;
    document.querySelectorAll('[data-sc-section]').forEach(initSetupCarousel);
  }

  function waitForSwiper(callback) {
    if (typeof Swiper !== 'undefined') {
      callback();
      return;
    }

    var tries = 0;
    var timer = setInterval(function () {
      if (typeof Swiper !== 'undefined' || ++tries > 40) {
        clearInterval(timer);
        if (typeof Swiper !== 'undefined') callback();
      }
    }, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      waitForSwiper(boot);
    });
  } else {
    waitForSwiper(boot);
  }

  document.addEventListener('shopify:section:load', function (e) {
    waitForSwiper(function () {
      var root = document.getElementById('sc-' + e.detail.sectionId);
      if (root) {
        root.dataset.scInit = 'false';
        initSetupCarousel(root);
      }
    });
  });
})();
